import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { browserHistory } from 'react-router';
import { IPortalSectionProps } from 'models/portal/page/portalpagesection';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import * as c from 'models/constants';
import { Button } from 'components';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { IUserPreferences } from 'models/user/userpreferences';
import { thumbUrl } from 'helpers/common';

require('./style.css');

interface IProps extends IPortalSectionProps {
	t?: (key: string, options?: any) => string;
	context: any;
	userPreferences?: IUserPreferences;
}

@connect(
	(state: IStore) => ({
		languageDomainValues: state.domainValues.languages,
		userLanguage: state.userLanguage,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType3Component extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.onButtonClick = this.onButtonClick.bind(this);
	}

	public onButtonClick(e: React.SyntheticEvent) {
		e.preventDefault();

		const { isAuthenticated, signinRedirectJoin } = this.props.context;

		if (isAuthenticated()) {
			const url = '/profile/' + this.props.userPreferences.code;
			browserHistory.push(url);
		} else {
			signinRedirectJoin();
		}
	}

	public render() {
		const { elements } = this.props.section.items[0];
		const { t } = this.props;
		const { isAuthenticated } = this.props.context;

		return (
			<div className="portalPageSectionType3">
				<div>
					{/* ViewType1 */}
					<div
						className="splashImage"
						style={{ backgroundImage: `url(${thumbUrl((elements[10] as ISectionImageElement).imageUrl)})` }}
					>
						<div className="container">
							<div className="splashTitleWrapper">
								<div className="row">
									<div className="col-md-12">
										<h1>{(elements[11] as ISectionTextElement).text}</h1>
										{!isAuthenticated() ? (
											<a href="#" onClick={this.onButtonClick} target="_blank" className="signUpButton">
												<img src={require('containers/Html/icons/sign_email.svg')} className="icon" />
												<span className="text">{t('PortalPage_Section_Type3_Subtitle')}</span>
											</a>
										) : null}
									</div>
								</div>
								<div className="row">
									<div className="col-md-12 getStartedBtn">
										<Button onClick={this.onButtonClick}>
											{t('PortalPage_SectionItem_PortalPageSectionGetStarted')}
										</Button>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/* ViewType3 */}
					<div className="infoContainer">
						<div className="container">
							<div className="infoBox">
								<div className="row getStartedViewType3 clear">
									<div className="col-lg-4 item">
										<h1 className="header">{(elements[1] as ISectionTextElement).text}</h1>
										<h3 className="subtitle">{(elements[2] as ISectionTextElement).text}</h3>
									</div>
									<div className="col-lg-4 item">
										<h1 className="header">{(elements[4] as ISectionTextElement).text}</h1>
										<h3 className="subtitle">{(elements[5] as ISectionTextElement).text}</h3>
									</div>
									<div className="col-lg-4 item">
										<h1 className="header">{(elements[7] as ISectionTextElement).text}</h1>
										<h3 className="subtitle">{(elements[8] as ISectionTextElement).text}</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const ViewType3 = withAuthContext(ViewType3Component);

export { ViewType3 };
